class PdpDynamicBlock extends HTMLElement {
  connectedCallback() {
    this.speed  = parseFloat(this.dataset.speed) || 3;
    this.colors = JSON.parse(this.dataset.colors || '[]');

    const rawTexts = JSON.parse(this.dataset.texts || '[]');
    const texts = rawTexts.filter(t => t.trim() !== '');
    if (!texts.length) return;

    const ENTER = 0.45;
    const EXIT  = 0.35;

    const randomNum = () => Math.floor(Math.random() * 500) + 1;

    const viewport = this.querySelector('.pdpb-viewport');
    viewport.style.height =
      `calc(${this.dataset.fontSize}px * 1.6 + ${this.dataset.paddingV}px * 2)`;

    this.slides = texts.map((text, i) => {
      const num = randomNum();
      const numberColor = this.colors[i] || '';

      let html = text.replace(/\{n\}/g, num);
      if (numberColor) {
        html = html.replace(
          /(\d+)/g,
          `<span style="color:${numberColor};font-weight:700;">$1</span>`
        );
      }

      const div = document.createElement('div');
      div.className = 'pdpb-slide';
      div.innerHTML = html;
      div.style.fontSize   = this.dataset.fontSize + 'px';
      div.style.fontWeight = this.dataset.fontWeight;
      div.style.color      = this.dataset.textColor;
      div.style.padding    = `${this.dataset.paddingV}px 0`;
      div.style.opacity    = '0';
      div.style.transform  = 'translateY(100%)';
      div.style.whiteSpace = 'pre';
      viewport.appendChild(div);
      return div;
    });

    // İlk slide'ı göster
    this.slides[0].style.transition = 'none';
    this.slides[0].style.transform  = 'translateY(0)';
    this.slides[0].style.opacity    = '1';

    if (this.slides.length === 1) return;

    let current = 0;
    setInterval(() => {
      const next = (current + 1) % this.slides.length;
      const cur  = this.slides[current];
      const nxt  = this.slides[next];

      // Her geçişte yeni random sayı üret ve innerHTML güncelle
      const texts = JSON.parse(this.dataset.texts || '[]').filter(t => t.trim() !== '');
      const newNum = randomNum();
      const numberColor = this.colors[next] || '';
      let html = texts[next].replace(/\{n\}/g, newNum);
      if (numberColor) {
        html = html.replace(
          /(\d+)/g,
          `<span style="color:${numberColor};font-weight:700;">$1</span>`
        );
      }
      nxt.innerHTML = html;

      cur.style.transition = `transform ${EXIT}s ease, opacity ${EXIT}s ease`;
      cur.style.transform  = 'translateY(-100%)';
      cur.style.opacity    = '0';

      nxt.style.transition = 'none';
      nxt.style.transform  = 'translateY(100%)';
      nxt.style.opacity    = '0';
      nxt.getBoundingClientRect();
      nxt.style.transition = `transform ${ENTER}s ease, opacity ${ENTER}s ease`;
      nxt.style.transform  = 'translateY(0)';
      nxt.style.opacity    = '1';

      current = next;
    }, this.speed * 1000);
  }
}

customElements.define('pdp-dynamic-block', PdpDynamicBlock);